export const EXPERIENCE_PLAYER_BASE_URL =
  process.env.EXPERIENCE_PLAYER_BASE_URL ||
  'https://experience-player-np-ci-as.azurewebsites.net'

export const LOCAL_STORAGE_KEY = 'experiencePlayer_link'

export const POLL_INTERVAL_MS = 30000

export const DEFAULT_TTL_SECONDS = 86400
